import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
	UserOutlined,
	LoadingOutlined,
	BellOutlined,
	SearchOutlined,
	GiftOutlined,
	MessageOutlined,
	CalendarOutlined,
	HomeOutlined,
	InboxOutlined,
	CheckOutlined,
	NotificationOutlined,
	InfoCircleOutlined,
	CheckCircleOutlined,
	WarningOutlined,
	CloseCircleOutlined,
	LinkOutlined,
} from '@ant-design/icons';
import { Layout, Menu, Avatar, ConfigProvider, Spin, Skeleton, Badge, Input, theme as antTheme, Drawer, Empty, Tag, Button, App as AntApp } from 'antd';
import AntdAppBridge from '../../../Libs/Helper/AntdAppBridge';
import "../../../Assets/css/layouts.css"
import { LogoutReducer } from '../../LoginForm/Reducer/LoginReducer';
import { getLayout } from '../Reducer/LayoutReducer';
import CommunicationService from '../../Communication/Services/CommunicationService';
import { Link } from 'react-router-dom';
import SessionTimeout from '../../../Libs/Devices/SessionTimeout';
import LanguageSwitcher from '../../../Libs/i18n/LanguageSwitcher';
import { withT } from '../../../Libs/i18n/I18nContext';
import api from '../../../Libs/Api/AxiosConfig';
import { mergeBranding } from '../../../Libs/Branding/brands';
import { platformBrandName } from '../../../Libs/Branding/platform';


//import SessionTimeout from '../../../Libs/Devices/SessionTimeout';

const { Header, Sider, Content, Footer } = Layout;




export class Layouts extends Component {

	constructor(props) {
		super(props);
		this.state = {
			collapsed: false,
			// notifications
			notifOpen: false,
			notifLoading: false,
			notifItems: [],
			notifUnreadHint: 0,
			notifReadIds: this.loadReadIds(),
			// search
			searchQ: '',
			searchOpen: false,
			searchLoading: false,
			searchResults: [],
			commUnread: 0,
		}
		this.recaptchaRef = React.createRef();
		this._searchTimer = null;
		this._searchSeq = 0;
		this._notifTimer = null;
	}

	componentDidMount() {
		this.props.getLayout();
		this.startPolling();
		document.addEventListener('mousedown', this.handleOutsideClick);
		document.addEventListener('visibilitychange', this.onVisibility);
	}

	// Polling yalnız sekme GÖRÜNÜRken çalışır (arka planda gereksiz istek/yük yok).
	startPolling = () => {
		this.stopPolling();
		this.fetchNotifications();
		this.fetchCommUnread();
		this._notifTimer = setInterval(this.fetchNotifications, 60000);
		this._commTimer = setInterval(this.fetchCommUnread, 30000);
	}

	stopPolling = () => {
		if (this._notifTimer) { clearInterval(this._notifTimer); this._notifTimer = null; }
		if (this._commTimer) { clearInterval(this._commTimer); this._commTimer = null; }
	}

	onVisibility = () => {
		if (document.hidden) this.stopPolling();
		else this.startPolling(); // geri dönünce anında tazele + yeniden başlat
	}

	fetchCommUnread = async () => {
		try {
			const res = await CommunicationService.unread({});
			if (res.data && typeof res.data.unread === 'number') this.setState({ commUnread: res.data.unread });
		} catch (e) { /* sessiz */ }
	}

	componentWillUnmount() {
		this.stopPolling();
		if (this._searchTimer) clearTimeout(this._searchTimer);
		document.removeEventListener('mousedown', this.handleOutsideClick);
		document.removeEventListener('visibilitychange', this.onVisibility);
	}

	handleOutsideClick = (e) => {
		if (this._searchWrapRef && !this._searchWrapRef.contains(e.target)) {
			if (this.state.searchOpen) this.setState({ searchOpen: false });
		}
	}

	loadReadIds = () => {
		try {
			const raw = localStorage.getItem('bonus.notif.read');
			const arr = raw ? JSON.parse(raw) : [];
			return Array.isArray(arr) ? arr : [];
		} catch { return []; }
	}

	saveReadIds = (ids) => {
		try { localStorage.setItem('bonus.notif.read', JSON.stringify(ids.slice(-200))); } catch {}
	}

	fetchNotifications = async () => {
		this.setState({ notifLoading: true });
		try {
			const res = await api.post('/User/Notifications/Feed', {});
			const r = res.data.payload;
			if (r.status) {
				this.setState({
					notifLoading: false,
					notifItems: r.data?.items || [],
					notifUnreadHint: r.data?.totalUnreadHint || 0,
				});
			} else {
				this.setState({ notifLoading: false });
			}
		} catch (e) {
			this.setState({ notifLoading: false });
		}
	}

	openNotif = () => this.setState({ notifOpen: true });
	closeNotif = () => this.setState({ notifOpen: false });

	markAllRead = async () => {
		// Localde tüm id'leri okundu işaretle (anlık UI)
		const allIds = this.state.notifItems.map(it => it.id);
		const next = Array.from(new Set([...this.state.notifReadIds, ...allIds]));
		this.setState({
			notifReadIds: next,
			// Admin push'ları için yerel state'te de isRead'i true yap
			notifItems: this.state.notifItems.map(it =>
				it.kind === 'admin_push' ? { ...it, isRead: true } : it
			),
		});
		this.saveReadIds(next);
		// Sunucu tarafında admin push'ları için DB güncellemesi
		try { await api.post('/User/Notifications/MarkAllRead', {}); } catch {}
	}

	markOneRead = (it) => {
		// it: { id (string "admin:42"), rawId, kind, ... } VEYA sadece string id (geri uyumluluk)
		const item = typeof it === 'object' ? it : this.state.notifItems.find(x => x.id === it);
		const id = item?.id ?? it;
		if (this.state.notifReadIds.includes(id)) return;
		const next = [...this.state.notifReadIds, id];
		this.setState({
			notifReadIds: next,
			notifItems: this.state.notifItems.map(x =>
				x.id === id && x.kind === 'admin_push' ? { ...x, isRead: true } : x
			),
		});
		this.saveReadIds(next);
		// Admin push ise sunucuya da gönder
		if (item?.kind === 'admin_push' && item.rawId) {
			api.post('/User/Notifications/MarkRead', { id: item.rawId }).catch(() => {});
		}
	}

	onSearchChange = (e) => {
		const q = e.target.value;
		this.setState({ searchQ: q, searchOpen: true });
		if (this._searchTimer) clearTimeout(this._searchTimer);
		const trimmed = q.trim();
		if (trimmed.length < 2) {
			this.setState({ searchResults: [], searchLoading: false });
			return;
		}
		this._searchTimer = setTimeout(() => this.runSearch(trimmed), 300);
	}

	runSearch = async (q) => {
		const seq = ++this._searchSeq;
		this.setState({ searchLoading: true });
		try {
			const res = await api.post('/User/Search/Quick', { query: q });
			if (seq !== this._searchSeq) return; // outdated
			const r = res.data.payload;
			this.setState({
				searchLoading: false,
				searchResults: r.status ? (r.data?.reservations || []) : [],
			});
		} catch (e) {
			if (seq !== this._searchSeq) return;
			this.setState({ searchLoading: false, searchResults: [] });
		}
	}

	closeSearch = () => this.setState({ searchOpen: false });

	unreadCount = () => {
		const ids = this.state.notifReadIds || [];
		return this.state.notifItems.filter(it => {
			// Admin push'larında sunucu isRead'i otoriter
			if (it.kind === 'admin_push') return !it.isRead && !ids.includes(it.id);
			return !ids.includes(it.id);
		}).length;
	}

	fmtRelTime = (ts) => {
		if (!ts) return '';
		const d = new Date(String(ts).replace(' ', 'T'));
		const diff = (Date.now() - d.getTime()) / 1000;
		const t = this.props.t;
		if (diff < 60) return t('time.justNow');
		if (diff < 3600) return t('time.minutesAgo', { n: Math.floor(diff / 60) });
		if (diff < 86400) return t('time.hoursAgo',   { n: Math.floor(diff / 3600) });
		if (diff < 86400 * 30) return t('time.daysAgo', { n: Math.floor(diff / 86400) });
		return String(ts).slice(0, 10);
	}

	renderSearchDropdown = () => {
		const { t } = this.props;
		const { searchQ, searchLoading, searchResults } = this.state;
		const q = searchQ.trim();
		if (q.length < 2) {
			return <div style={{ padding: 14, color: '#999', fontSize: 13 }}>{t('nav.searchTyping')}</div>;
		}
		if (searchLoading) {
			return <div style={{ padding: 14, color: '#999', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
				<Spin size='small' /> {t('nav.searchLoading')}
			</div>;
		}
		if (searchResults.length === 0) {
			return <div style={{ padding: 14, color: '#999', fontSize: 13 }}>{t('nav.searchEmpty')}</div>;
		}
		const STATUS_COLOR = { 1: 'green', 2: 'red', 4: 'gold' };
		return (
			<div>
				{searchResults.map(r => (
					<Link
						key={r.id}
						to='/Reservations'
						onClick={this.closeSearch}
						style={{
							display: 'block', padding: '10px 14px',
							borderBottom: '1px solid #f5efe1',
							color: 'inherit', textDecoration: 'none',
						}}
						className='tz-search-result'
					>
						<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
							<div style={{
								width: 32, height: 32, borderRadius: 8,
								background: 'rgba(109,40,217,0.10)',
								display: 'flex', alignItems: 'center', justifyContent: 'center',
								color: '#6d28d9', flexShrink: 0,
							}}>
								<HomeOutlined />
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ fontWeight: 600, fontSize: 13, color: '#222', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
									{r.primaryGuest || '—'}
									{r.refNo && <Tag color='gold' style={{ marginLeft: 6, fontFamily: 'monospace' }}>{r.refNo}</Tag>}
								</div>
								<div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
									{r.hotelName || '—'} · {r.checkIn ? String(r.checkIn).slice(0, 10) : ''}
								</div>
							</div>
							<Tag color={STATUS_COLOR[r.status] || 'default'} style={{ margin: 0 }}>
								{r.status === 1 ? '✓' : r.status === 2 ? '×' : '⏱'}
							</Tag>
						</div>
					</Link>
				))}
				<Link
					to='/Reservations'
					onClick={this.closeSearch}
					style={{
						display: 'block', padding: '10px 14px',
						textAlign: 'center', fontSize: 12, fontWeight: 600,
						color: '#6d28d9', background: 'rgba(109,40,217,0.05)',
					}}
				>
					{t('nav.searchSeeAll')}
				</Link>
			</div>
		);
	}

	renderNotifItem = (it) => {
		const { t } = this.props;
		// Admin push: server isRead otoriter; diğerleri localStorage
		const isRead = it.kind === 'admin_push'
			? !!it.isRead || this.state.notifReadIds.includes(it.id)
			: this.state.notifReadIds.includes(it.id);

		// Tip → renk + ikon
		const TYPE_VISUAL = {
			info:    { color: '#1890ff', bg: '#e6f4ff', icon: <InfoCircleOutlined /> },
			success: { color: '#52c41a', bg: '#f6ffed', icon: <CheckCircleOutlined /> },
			warning: { color: '#fa8c16', bg: '#fff7e6', icon: <WarningOutlined /> },
			danger:  { color: '#cf1322', bg: '#fff1f0', icon: <CloseCircleOutlined /> },
		};

		let icon, title, body, accentColor = '#6d28d9', accentBg = 'rgba(109,40,217,0.06)';
		let extraTag = null;

		if (it.kind === 'admin_push') {
			const v = TYPE_VISUAL[it.type] || TYPE_VISUAL.info;
			icon = v.icon;
			accentColor = v.color;
			accentBg = isRead ? '#fff' : v.bg;
			title = it.title || t('nav.notifKindAdmin') || 'Yönetici Bildirimi';
			body = it.body || '';
			extraTag = <Tag color='gold' style={{ fontSize: 9, margin: 0, padding: '0 5px', lineHeight: '16px' }}>
				<NotificationOutlined /> ADMIN
			</Tag>;
		} else if (it.kind === 'earning') {
			icon = <GiftOutlined />;
			title = t('nav.notifKindEarning');
			body = t('nav.notifKindEarningBody', { points: Number(it.points || 0).toFixed(0), hotel: it.hotel || '—' });
		} else if (it.kind === 'ticket') {
			icon = <MessageOutlined />;
			title = t('nav.notifKindTicket');
			body = t('nav.notifKindTicketBody', { subject: it.subject || it.ticketNo || '' });
		} else {
			// Rezervasyon olayları (Notifications/Feed): event → çevirili başlık + renk (çeviri yoksa İngilizce fallback).
			const EV = {
				new_request:      ['_notif_new_request_', 'New booking request', '#fa8c16'],
				awaiting_payment: ['_notif_awaiting_payment_', 'Confirmed — payment due', '#fa8c16'],
				confirmed:        ['_notif_confirmed_', 'Booking confirmed', '#52c41a'],
				declined:         ['_notif_declined_', 'Booking declined by supplier', '#cf1322'],
				cancelled:        ['_notif_cancelled_', 'Booking cancelled', '#cf1322'],
				cancel_request:   ['_notif_cancel_request_', 'Cancellation requested', '#fa8c16'],
				change_request:   ['_notif_change_request_', 'Change requested', '#fa8c16'],
				updated:          ['_notif_updated_', 'Booking updated', '#1890ff'],
			};
			const ev = EV[it.event] || ['nav.notifKindReservation', 'Reservation', '#6d28d9'];
			icon = <CalendarOutlined />;
			accentColor = ev[2];
			accentBg = isRead ? '#fff' : 'rgba(0,0,0,0.04)';
			title = t(ev[0]) !== ev[0] ? t(ev[0]) : ev[1];
			body = `${it.refNo || '—'} · ${it.hotel || '—'}`;
		}

		// Y-4 defense-in-depth: link XSS koruması. Backend zaten sanitize eder ama
		// eski DB kayıtları veya cache nedeniyle frontend'de de scheme whitelist uygulanır.
		const safeLink = (raw) => {
			if (typeof raw !== 'string') return '#';
			const v = raw.trim();
			if (v === '' || v === '#') return '#';
			if (v.startsWith('//')) return '#'; // protocol-relative
			if (/^https?:\/\//i.test(v)) return v;
			if (/^[a-z][a-z0-9+\-.]*:/i.test(v)) return '#'; // javascript:, data:, vbscript:, mailto:, vs.
			if (/[\x00-\x1F\x7F]/.test(v)) return '#'; // eslint-disable-line no-control-regex
			return v;
		};
		const linkTo = safeLink(it.link);
		const isExternal = /^https?:\/\//i.test(linkTo);

		const content = (
			<div style={{ display: 'flex', gap: 10 }}>
				<div style={{
					width: 36, height: 36, borderRadius: 10,
					background: isRead ? '#f5f5f5' : accentColor,
					color: isRead ? '#999' : '#fff',
					display: 'flex', alignItems: 'center', justifyContent: 'center',
					fontSize: 16, flexShrink: 0,
				}}>{icon}</div>
				<div style={{ flex: 1, minWidth: 0 }}>
					<div style={{
						fontWeight: 600, fontSize: 13, color: '#222',
						display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'center',
					}}>
						<span style={{
							flex: 1, minWidth: 0,
							whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
						}}>{title}</span>
						<span style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
							{extraTag}
							{!isRead && <span style={{
								width: 8, height: 8, background: accentColor, borderRadius: 999,
							}} />}
						</span>
					</div>
					{body && (
						<div style={{
							fontSize: 12, color: '#666', marginTop: 2,
							display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
							overflow: 'hidden', textOverflow: 'ellipsis',
							whiteSpace: it.kind === 'admin_push' ? 'pre-wrap' : 'nowrap',
						}}>
							{body}
						</div>
					)}
					<div style={{
						fontSize: 11, color: '#999', marginTop: 4,
						display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 6,
					}}>
						<span>{this.fmtRelTime(it.ts)}</span>
						{it.kind === 'admin_push' && it.link && (
							<span style={{ color: accentColor, display: 'flex', alignItems: 'center', gap: 3 }}>
								<LinkOutlined /> Aç
							</span>
						)}
					</div>
				</div>
			</div>
		);

		const baseStyle = {
			display: 'block',
			padding: '12px 14px',
			borderBottom: '1px solid #f5efe1',
			color: 'inherit', textDecoration: 'none',
			background: isRead ? '#fff' : accentBg,
			borderLeft: isRead ? '3px solid transparent' : `3px solid ${accentColor}`,
			cursor: 'pointer',
		};

		// Admin push + link yoksa sadece okundu işaretle (Link'e sarılmasın)
		if (it.kind === 'admin_push' && !it.link) {
			return (
				<div
					key={it.id}
					onClick={() => this.markOneRead(it)}
					style={baseStyle}
				>
					{content}
				</div>
			);
		}

		// Dış link?
		if (isExternal) {
			return (
				<a
					key={it.id}
					href={linkTo}
					target='_blank'
					rel='noopener noreferrer'
					onClick={() => { this.markOneRead(it); this.closeNotif(); }}
					style={baseStyle}
				>
					{content}
				</a>
			);
		}

		return (
			<Link
				key={it.id}
				to={linkTo}
				onClick={() => { this.markOneRead(it); this.closeNotif(); }}
				style={baseStyle}
			>
				{content}
			</Link>
		);
	}

	setCollapsed = (c) => {
		this.setState({
			collapsed: c
		})
	}



	/**
	 * Modül label'ını dile göre çöz: önce nav.modules.<labelCode>, yoksa
	 * DB'den gelen Türkçe label fallback. Bu sayede yeni modül eklenince locale'e
	 * çeviri eklenmediği sürece UI kırılmaz, eski TR isim görünür.
	 */
	moduleLabel = (item) => {
		const { t } = this.props;
		// Backend label'ı çeviri kodu (_agency_xxx_); doğrudan t() ile çöz.
		// DB'de karşılığı yoksa t() kodu döndürür (kırılmaz).
		const code = item.label || item.labelCode || '';
		return t(code);
	}

	reOrgMenu = () => {

		let menu = [];


		const Icon = ({ type, ...rest }) => {
			const icons = require(`@ant-design/icons`);
			if (icons[type]) {
				const Component = icons[type];
				return <Component {...rest} />
			} else {
				const Component = icons["MenuFoldOutlined"];
				return <Component {...rest} />
			}

		}


		this.props.Layout.modules.filter(item => item.parentId === 0).forEach(item => {

			// Transfer şimdilik "Coming soon" → menüde disabled (alt menü açılmaz, link yok).
			if (this.isComingSoon(item)) {
				menu.push({ key: item.key, icon: <Icon type={item.icon} />, disabled: true, label: this.comingSoonLabel(item) });
				return;
			}

			if (this.reSubOrgMenu(item.key).length > 0) {
				const a = {
					key: item.key,
					label: this.moduleLabel(item),
					icon: <Icon type={item.icon} />,
					children: this.reSubOrgMenu(item.key)
				}
				menu.push(a);
			} else {
				let link = "#"

				if (item.value !== null) {
					link = item.value
				} else {
					link = "#"
				}
				const a = {
					key: item.key,
					label: <Link to={link}>{this.moduleLabel(item)}</Link>,
					icon: <Icon type={item.icon} />,
				}
				menu.push(a);
			}



		});


		// Booking Messages (birleşik mesajlaşma) — global unread rozetiyle
		menu.push({
			key: "99msg",
			label: <Link to="/BookingMessages"><span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>{this.props.t('_booking_messages_') !== '_booking_messages_' ? this.props.t('_booking_messages_') : 'Booking Messages'}{this.state.commUnread > 0 && <Badge count={this.state.commUnread} size="small" />}</span></Link>,
			icon: <Icon type={"MessageOutlined"} />,
		});

		// Legal — public hukuki metin sayfaları (açılır parent). NOT: modules'tan gelen dinamik
		// "Help" ayrı; bu parent 'Legal' olarak adlandırıldı (çakışma olmasın).
		const tl = (k, fb) => this.props.t(k) !== k ? this.props.t(k) : fb;
		menu.push({
			key: "99legal",
			label: tl('_legal_', 'Legal'),
			icon: <Icon type={"SafetyCertificateOutlined"} />,
			children: [
				{ key: "99legal-terms", label: <Link to="/terms">{tl('_terms_', 'Terms')}</Link>, icon: <Icon type={"FileTextOutlined"} /> },
				{ key: "99legal-privacy", label: <Link to="/privacy">{tl('_privacy_', 'Privacy')}</Link>, icon: <Icon type={"SafetyOutlined"} /> },
				{ key: "99legal-distance", label: <Link to="/distance-sales">{tl('_commercial_terms_', 'Commercial Terms')}</Link>, icon: <Icon type={"ProfileOutlined"} /> },
			],
		});

		const ax = {
			key: "99a",
			label: <Link to="/Logout">{this.props.t('_logout_')}</Link>,
			icon: <Icon type={"LogoutOutlined"} />,
		}
		menu.push(ax);



		return menu;

	}

	// Transfer (coming soon) tespiti: değeri /Transfer ile başlayan veya parent "_transfer_" başlığı.
	isComingSoon = (item) => {
		const v = item.value ? String(item.value) : '';
		return v.startsWith('/Transfer') || item.label === '_transfer_';
	}

	comingSoonLabel = (item) => (
		<span className='noSelectStyle' style={{ display: 'inline-flex', alignItems: 'center', gap: 8, opacity: .6 }}>
			{this.moduleLabel(item)}
			<span style={{ fontSize: 9, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px', color: '#8b8b97', background: '#f0f0f3', border: '1px solid #e0e0e6', borderRadius: 999, padding: '1px 7px' }}>
				{this.props.t('_coming_soon_') !== '_coming_soon_' ? this.props.t('_coming_soon_') : 'Coming soon'}
			</span>
		</span>
	)

	reSubOrgMenu = (id) => {
		let menu = [];
		this.props.Layout.modules.filter(item => item.parentId === id).forEach(item => {

			// Komisyon ödeme raporu YALNIZ owner (user_type=1) menüsünde görünür (backend de zorlar).
			if (item.value === '/Report/Commission' && Number(this.props.Layout.userType) !== 1) {
				return;
			}

			let link = "#"

			if (item.value !== null) {
				link = item.value
			} else {
				link = "#"
			}
			const a = {
				key: item.key,
				label: <Link to={link}>{this.moduleLabel(item)}</Link>,
			}
			menu.push(a);
		});
		return menu;
	}

	logout = () => {

	}



	render() {

		const { collapsed } = this.state;
		const { loading,
			companyCode,
			title,
			status,
			status_code,
			company_type_name,
			firstName,
			lastName,
			avatar,
			userType
		} = this.props.Layout;

		// Marka: API'den (Apps.branding) gelir, gelmezse DEFAULT_BRANDING (Tourzone).
		// Logo, ConfigProvider token'ları ve bileşen temaları buradan okunur.
		const brand = mergeBranding(this.props.Apps && this.props.Apps.branding);

		return (
			<ConfigProvider
				theme={{
					algorithm: antTheme.defaultAlgorithm,
					token: {
						fontFamily: "Roboto",
						colorPrimary: brand.colorPrimary,
						colorLink: brand.colorLink,
						colorInfo: brand.colorPrimary,
						borderRadius: 8
					},
					// Marka token'ları API'den (Apps.branding) gelir; gelmezse
					// DEFAULT_BRANDING (Tourzone) değerleri kullanılır.
					components: brand.components
				}}
			>
				<AntApp component={false}>
				<AntdAppBridge>
				<Layout
					className='layouts tz-shell'
					style={{
						minHeight: '100vh',
					}}
				>
					<Sider
						className='tz-sider'
						collapsible
						collapsed={collapsed}
						onCollapse={(value) => this.setCollapsed(value)}
						breakpoint="md"
						collapsedWidth="0"
						width={250}
					>

						<div className={`tz-sider-logo ${collapsed ? 'collapsed' : ''}`}>
							<img className='tz-sider-logo-full' src={brand.logo} alt={brand.brand} />
						</div>

						<div className='companyInfo tz-sider-user'>

							{loading ?

								<div className='col-md-12 mt-2 mb-2 text-center'>
									<Spin indicator={<LoadingOutlined spin />} size="large" />
								</div>

								:
								<div className='row align-items-center g-0 w-100'>
									<div className={!collapsed ? 'col-auto ps-1 pe-2' : 'col-auto mx-auto'} >
										{(avatar === null || avatar === "") ?
											<Avatar shape="square" size={collapsed ? 36 : 46} icon={<UserOutlined />} className='tz-sider-avatar' />
											:
											<Avatar shape="square" size={collapsed ? 36 : 42} src={avatar} className='tz-sider-avatar' />
										}
									</div>
									{!collapsed &&
										<div className='col ps-2 overflow-hidden'>
											<div className='title tz-sider-user-name'>
												<b>{firstName} {lastName}</b>
											</div>
											{(Number(userType) === 2 || Number(userType) === 3) &&
												<div className='tz-sider-user-role'>
													<span style={{ display: 'inline-block', padding: '1px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, background: Number(userType) === 2 ? '#fffbe6' : '#f9f0ff', color: Number(userType) === 2 ? '#d48806' : '#722ed1' }}>
														{Number(userType) === 2 ? 'Affiliate' : 'Sales Rep'}
													</span>
												</div>
											}
											<div className='company tz-sider-user-meta'>
												{title}
											</div>
											<div className='company tz-sider-user-meta'>
												{companyCode}
											</div>
										</div>
									}
								</div>
							}
						</div>

						{!collapsed && !loading &&
							<div className='tz-sider-tags'>
								{company_type_name &&
									<span className='tz-pill tz-pill-type'>{company_type_name}</span>
								}
								{status_code &&
									<span className={`tz-pill tz-pill-status s${status}`}>
										<span className='dot'></span> {this.props.t(status_code)}
									</span>
								}
							</div>
						}

						{loading ?

							<div className='col-md-12 text-center mt-5'>
								<Spin indicator={<LoadingOutlined spin />} size="large" />
							</div>

							:

							<Menu className='tz-sider-menu' theme="dark" defaultSelectedKeys={['1']} defaultOpenKeys={['99legal']} mode="inline" items={this.reOrgMenu()} />
						}

					</Sider>
					<Layout>
						<Header className='tz-header'>
							<div
								className='tz-header-search'
								ref={(el) => { this._searchWrapRef = el; }}
								style={{ position: 'relative' }}
							>
								<Input
									prefix={<SearchOutlined style={{ color: '#9ca3af' }} />}
									placeholder={this.props.t('nav.searchPlaceholder')}
									bordered={false}
									className='tz-header-search-input'
									value={this.state.searchQ}
									onChange={this.onSearchChange}
									onFocus={() => this.setState({ searchOpen: true })}
									allowClear
								/>
								{this.state.searchOpen && this.state.searchQ &&
									<div style={{
										position: 'absolute', top: '100%', left: 0, right: 0,
										marginTop: 6,
										background: '#fff',
										border: '1px solid #e8e3d3',
										borderRadius: 10,
										boxShadow: '0 8px 24px rgba(0,0,0,0.10)',
										maxHeight: 420, overflowY: 'auto',
										zIndex: 1000,
									}}>
										{this.renderSearchDropdown()}
									</div>
								}
							</div>
							<div className='tz-header-actions'>
								<LanguageSwitcher />
								<div className='tz-header-divider'></div>
								<button type='button'
									className='tz-header-icon-btn'
									aria-label={this.props.t('nav.notifications')}
									onClick={this.openNotif}
								>
									<Badge count={this.unreadCount()} size='small' offset={[-2, 2]} color='#41009a'>
										<BellOutlined style={{ fontSize: 18, color: '#1f2937' }} />
									</Badge>
								</button>
								<div className='tz-header-divider'></div>
								<div className='tz-header-user'>
									{(avatar === null || avatar === "") ?
										<Avatar size={36} icon={<UserOutlined />} className='tz-header-avatar' />
										:
										<Avatar size={36} src={avatar} className='tz-header-avatar' />
									}
									<div className='tz-header-user-text'>
										<strong>{firstName || 'Tourzone'} {lastName || ''}</strong>
										<small>{title || this.props.t('nav.agencyPanel')}</small>
									</div>
								</div>
							</div>
						</Header>
						<Content className='tz-content'>

							{
								loading ? <Skeleton active paragraph={{ rows: 6 }} /> :
									this.props.children
							}


						</Content>
						<Footer
							className='no-print tz-footer'
						>
							<span>
								<strong>{platformBrandName(this.props.Apps && this.props.Apps.branding)}</strong> &copy; {new Date().getFullYear()} · {this.props.t('nav.rightsReserved')}
							</span>
							<SessionTimeout/>
						</Footer>
					</Layout>
				</Layout>

				<Drawer
					title={
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
							<span style={{ fontWeight: 600 }}>
								<BellOutlined style={{ color: '#6d28d9', marginRight: 8 }} />
								{this.props.t('nav.notifTitle')}
							</span>
							{this.unreadCount() > 0 &&
								<Button size='small' icon={<CheckOutlined />} onClick={this.markAllRead}>
									{this.props.t('nav.notifMarkAllRead')}
								</Button>
							}
						</div>
					}
					placement='right'
					width={380}
					open={this.state.notifOpen}
					onClose={this.closeNotif}
					styles={{ body: { padding: 0 } }}
				>
					{this.state.notifLoading
						? <div style={{ padding: 30, textAlign: 'center' }}><Spin /></div>
						: this.state.notifItems.length === 0
							? <div style={{ padding: 40 }}>
								<Empty
									image={<InboxOutlined style={{ fontSize: 48, color: '#ccc' }} />}
									description={<span style={{ color: '#999' }}>{this.props.t('nav.notifEmpty')}</span>}
								/>
							</div>
							: <div>{this.state.notifItems.map(this.renderNotifItem)}</div>
					}
				</Drawer>
				</AntdAppBridge>
				</AntApp>
			</ConfigProvider>

		);

	}
}

const mapStateToProps = (state) => ({
	Login: state.Login,
	Apps: state.Apps,
	Layout: state.Layout
})

const mapDispatchToProps = {
	LogoutReducer,
	getLayout
}

export default connect(mapStateToProps, mapDispatchToProps)(withT(Layouts))
